<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
  const setHtmlFontSize = () => {
    const htmlDom = document.getElementsByTagName("html")[0];
    let htmlWidth =
      document.documentElement.clientWidth || document.body.clientWidth;
    if (htmlWidth >= 750) {
      htmlWidth = 750;
    }
    if (htmlWidth <= 320) {
      htmlWidth = 320;
    }
    htmlDom.style.fontSize = `${htmlWidth / 7.5}px`;
  };
  window.onresize = setHtmlFontSize;
  setHtmlFontSize();
export default {
  data() {
    return {};
  },
  created() {
    if (document.body.clientWidth >= 992) {
      let url = this.$route.name.replace('mobile','pc')
      this.$router.push({ name: url });
    }
  },
  
};
</script>

<style scoped>
</style>